import { defaultPrintOptions, type PrintOptions } from '#features/PrintOptions/PrintOptions'

export const hasPrintOptionsChanged = (options?: PrintOptions) => {
  if (!options) {
    return false
  }

  return !(Object.keys(defaultPrintOptions) as (keyof PrintOptions)[]).every((key) => options[key] === defaultPrintOptions[key])
}
